

<form #form="ngForm" (ngSubmit)="onSubmit(form)">
    <div class="form-row">
        <input required email type="email" name="email" [(ngModel)]="model.email" placeholder="{{ 'shared.label.email' | translate }}"  />
    </div>

    <div class="form-row">
        <input required type="password" name="password" [(ngModel)]="model.password" autocomplete='password' placeholder="{{ 'shared.label.password' | translate }}" />
    </div>

    <div class="form-row form-checkboxes form-checkboxes-inline">
        <label>
            <input name="remember" type="checkbox" value="remember" [(ngModel)]="model.remember" />
            {{ 'auth.login.remember-me' | translate }}
        </label>
        <a class="form-forgot" [href]="getPasswordAppUrl()">{{ 'auth.login.forgot-password' | translate }}</a>
    </div>

    <div class="form-row">
        <re-captcha
            *ngIf="captcha"
            (resolved)="onCaptchaSuccess($event)"
            [siteKey]="captachKey">
        </re-captcha>
    </div>

    <div class="form-row">
        <button [disabled]="form.form.invalid" class="button button-full-width button-big button-primary">{{ 'auth.login.button.login' | translate }}</button>
    </div>

    <div class="form-row form-row-split">
        <a class="form-signup" routerLink="/signup">{{ 'auth.login.signup' | translate }}</a>
        <a class="form-login-sso" routerLink="/login-sso">{{ 'auth.login.login-sso' | translate }}</a>
    </div>
</form>
